import Fuse from 'fuse.js';
import { useState, useEffect } from 'react';

type UseSearchHook<T> = {
  onSearch: (e: any) => void;
  query: string;
  searchResult: T[];
};

export const useClientSearch = <T extends { lastName: string }>(
  // @ts-ignore Fuse is not typed correctly
  options: Fuse.IFuseOptions<T>,
  list: T[],
): UseSearchHook<T> => {
  const [query, setQuery] = useState('');
  const [searchResult, setResult] = useState<T[]>([]);

  const onSearch = (e: any) => {
    setQuery(e?.detail?.value ?? '');
  };

  useEffect(() => {
    if (!query.trim()) {
      // Sort the list by lastName before setting state
      const sortedList = [...list].sort((a, b) => a.lastName.localeCompare(b.lastName));
      setResult(sortedList);
      return;
    }

    const fuse = new Fuse<T>(list, {
      threshold: 0.2,
      includeMatches: true,
      ...options,
    });

    const fuseResult = fuse.search(query);
    const sortedResult = fuseResult.map((res) => res.item).sort((a, b) => a.lastName.localeCompare(b.lastName));

    setResult(sortedResult);
  }, [query, list]);

  return { onSearch, query, searchResult };
};
